.selectedAttributeTd {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.selectedAttributeTd:hover {
	overflow: visible !important;
	white-space: normal !important;
}

.showOnRowHover {
	opacity: 0;
	transition: opacity 0.2s ease;
}

.rowHover:hover .showOnRowHover {
	opacity: 1;
}
